import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import './plugins/vuetify';
import App from './App.vue';
import api from './api';
import './filters';
import router from './router';
import store from './store';
import { omit } from 'lodash';

Vue.config.productionTip = false;

Vue.prototype.$api = api;

Vue.use(VueAnalytics, {
    id: 'UA-146426367-1',
    router,
    debug: {
        sendHitTask: !/localhost/i.test(window.location.hostname)
    }
});

router.afterEach(() => {
    let isFinishing = false;
    if (null === store.get('firstIncompleteSection') && !store.get('finished')) {
        store.set('finished', true);
        isFinishing = true;
    }
    api.post('/state', { data: omit(store.state, ['user', 'photo']), isFinishing }).catch(() => null);
});

async function init() {
    if (!/\/login/.test(window.location.href)) {
        try {
            const remoteState = await api.get('/state');
            if (remoteState && remoteState.data && remoteState.data.state) {
                store.commit('loadState', remoteState.data.state.data);
                const remotePhoto = await api.get('/photo');
                if (remotePhoto && remotePhoto.data && remotePhoto.data.photo) {
                    store.set('photo', remotePhoto.data.photo.src);
                }
            }
        } catch (err) {
            // nothing
        }
    }

    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app');
}
init();
